import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02b961fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cancelorder" }
const _hoisted_2 = {
  key: 0,
  class: "box"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#4475DD","font-size":"12px","margin-top":"20px"} }, "温馨提示：其他包裹正在查询物流状态，请您耐心等待取消结果！", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "t1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px"} }, "物流单取消后将无法恢复，您确认仍然要将选中的物流单取消么？", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "t2" }, "温馨提示：包裹需要查询物流状态，请您耐心等待取消结果！", -1))
const _hoisted_8 = { style: {"display":"flex","justify-content":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_exclamation_circle_filled = _resolveComponent("exclamation-circle-filled")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.orderBatchList && _ctx.orderBatchList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderBatchList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "orderBatchList",
              key: item
            }, [
              _createElementVNode("span", null, _toDisplayString(item.gwosOrderNo), 1),
              _createElementVNode("span", null, _toDisplayString(item.message), 1)
            ]))
          }), 128)),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_a_row, { justify: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { class: "txtCont" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_exclamation_circle_filled, { style: {"color":"#1964a6"} }),
                    _hoisted_6
                  ]),
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleGoto('cct')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("确认取消")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  style: {"margin-right":"10px"},
                  onClick: _ctx.handleCtrl
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("返回")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}